import(/* webpackMode: "eager" */ "/app/src/app/inventory/error.tsx");
